import React, { useState, useEffect } from 'react';
import moment from 'moment'
import Popup from '../components/Popup'
import TouchFeedback from '../components/TouchFeedback'
import classnames from 'classnames'

import DateTimePicker from "../components/DateTimePicker"
import styles from "./App.less"


function App(props) {
    console.log("props", props);

    let { showDatePanel, datePanelType, mateFormat, defaultDate, upState, model, I18N } = props

    // console.log({ showDatePanel, datePanelType, mateFormat, defaultDate, });

    const [show, setShow] = useState(false)
    const [currType, setCurrType] = useState("pre") //pre next

    const [formatMap, setFormatMap] = useState({ "year": "YYYY", "custom": mateFormat })

    const [formatType, setFormatType] = useState(defaultDate.length === 2 ? "custom" : "year")

    const _initval = moment().format(formatMap[formatType])
    const [preVal, setPreVal] = useState(_initval)
    const [nextVal, setNextVal] = useState(_initval)
    const [yeraVal, setYeraVal] = useState(_initval)
    const [dateVal, setDateVal] = useState(null)

    useEffect(() => {
        // console.log("useEffect showDatePanel", showDatePanel);
        if (showDatePanel) {
            // 打开面板
            setShow(showDatePanel)

            // 选择日期格式
            let _formatType = "year"

            if (datePanelType === "2" && defaultDate.length === 2) {
                _formatType = "custom"
            }

            // 选择日期默认值
            if (_formatType === "year") {
                setYeraVal(moment(defaultDate[0]).format("YYYY"))
                setPreVal(moment(defaultDate[0]).format("YYYY"))    //初始化的值取得是preVal，所以设置下
            }
            if (_formatType === "custom") {
                setPreVal(moment(defaultDate[0]).format(mateFormat))
                setNextVal(moment(defaultDate[1]).format(mateFormat))
            }
            setDateVal(null)

            setFormatMap({
                "year": "YYYY",
                "custom": mateFormat
            })

            setCurrType("pre")

            setFormatType(_formatType)

        }
    }, [props.showDatePanel])


    const params = {
        initDate: moment(preVal),
        value: dateVal,
        format: formatMap[formatType],
        onDateChange: e => {
            const strDate = moment(e).format(formatMap[formatType])
            // console.log("onDateChange", strDate);

            setDateVal(null)

            if (formatType === "year") {
                setYeraVal(strDate)
            }

            if (formatType === "custom") {
                if (currType === "pre") {
                    setPreVal(strDate)

                    if (moment(strDate) > moment(nextVal)) {
                        setNextVal(strDate)
                    }
                }
                if (currType === "next") {
                    setNextVal(strDate)

                    if (moment(strDate) < moment(preVal)) {
                        setPreVal(strDate)
                    }
                }
            }
        }
    }

    const toggleType = type => {
        const _format = formatMap[type]

        const _preVal = moment(preVal).format(_format)
        const _nextVal = moment(nextVal).format(_format)

        setFormatType(type)
        setCurrType("pre")

        setPreVal(_preVal)
        setNextVal(_nextVal)
        setDateVal(moment(_preVal))
    }

    const toggleInp = type => {
        setCurrType(type)

        if (type === "pre") {
            setDateVal(moment(preVal))
        }
        if (type === "next") {
            setDateVal(moment(nextVal))
        }
    }

    const confirmDate = () => {
        const res = []
        let dateType = 1
        if (formatType === "year") {
            res.push(yeraVal)
            dateType = 1
        }
        if (formatType === "custom") {
            res.push(preVal, nextVal)
            dateType = 2
        }


        model.invoke("handleDate", {
            dateVal: res,
            dateType
        })

        console.log("选择的日期", {
            dateVal: res,
            dateType
        });
    }

    return (
        <div>
            <Popup
                key='popup_picker_date'
                show={show}
                title={I18N("title")}
                header={CustomHeader}
                className={styles['date-popup-picker']}
                onCancel={() => {
                    // console.log("onCancel");
                    setShow(false)
                    upState("showDatePanel", false)
                }}
                onConfirm={() => {
                    // console.log("onConfirm", { preVal, nextVal });
                    setShow(false)
                    upState("showDatePanel", false)
                    confirmDate()
                }}
                footer={({ onConfirm, mustInput }) => CustomFooter({ onConfirm, mustInput, I18N })}
            >
                <div className={styles["i-popup-main"]}>
                    {
                        datePanelType === "2" && (
                            <div className={styles["navbar-box"]}>
                                <div className={styles["navbar"]}>
                                    <span className={classnames(styles["nav-item"], { [styles["active"]]: formatType === "year" })} onClick={() => { toggleType("year") }}>{I18N("slectY")}</span>
                                    <span className={classnames(styles["nav-item"], { [styles["active"]]: formatType === "custom" })} onClick={() => { toggleType("custom") }}>{I18N("slectC")}</span>
                                </div>
                            </div>
                        )
                    }
                    {
                        formatType === "custom" && datePanelType === "2" && (
                            <div className={styles["inp-box"]}>
                                <input type="text" value={preVal} readOnly onClick={() => {
                                    toggleInp("pre")
                                }}
                                    style={{
                                        borderColor: currType === "pre" ? "#276FF5" : "#f2f2f2"
                                    }}
                                />
                                <span>-</span>
                                <input type="text" value={nextVal} readOnly onClick={() => {
                                    toggleInp("next")
                                }}
                                    style={{
                                        borderColor: currType === "next" ? "#276FF5" : "#f2f2f2"
                                    }}
                                />
                            </div>
                        )
                    }
                    <div className={styles["picker-box"]}>
                        <DateTimePicker I18N={I18N} {...params} />
                    </div>
                </div>
            </Popup>

        </div>
    );
}

const CustomHeader = ({ onCancel, title }) => {
    return (
        <div className={classnames(styles['popup-header'], styles['border-buttom-1px'])}>
            <div className={styles['popup-header-title']}>{title}</div>
            <TouchFeedback activeClassName={styles['popup-header-btn-active']}>
                <div className={`kdfont kdfont-guanbi6 ${styles['icon-cancel']}`} onClick={onCancel} />
            </TouchFeedback>
        </div>
    )
}

const CustomFooter = ({ onConfirm, mustInput, I18N }) => {

    const locale = { confirm: I18N("select") }
    return (
        <div className={classnames(styles['popup-footer'], styles['border-buttom-1px'])}>
            {
                <TouchFeedback activeClassName={styles['popup-footer-btn-active']}>
                    <div className={styles[`popup-footer-confirm`]} onClick={onConfirm}>{locale.confirm}</div>
                </TouchFeedback>
            }
        </div>
    )
}

export default App;